import React from "react";

const InputField = ({
  value,
  placeholder,
  onChange,
  error,
  errorMessage,
  minLength,
  maxLength,
  required,
}) => {
  // Validar si el campo cumple con los requisitos de longitud
  const isValidLength = value.length >= minLength && value.length <= maxLength;

  // Determinar si mostrar el mensaje de error
  const showError =
    error && (required ? value.trim() === "" || !isValidLength : !isValidLength);

  const getErrorMessage = () => {
    if (value.trim() === "") {
      return "Campo obligatorio";
    } else if (value.length < minLength) {
      return `Mínimo ${minLength} caracteres`;
    } else if (value.length > maxLength) {
      return `El campo no puede superar los ${maxLength} caracteres`;
    }
    return errorMessage;
  };
  
  const handleInputChange = (e) => {
    const newValue = e.target.value; 
    onChange({ target: { value: newValue } }); 
  };

  return (
    <div className="flex flex-col gap-1">
      <div className="relative">
        <input
          type="text"
          value={value}
          placeholder={placeholder}
          required={required}
          onChange={handleInputChange}
          maxLength={maxLength}
          className={`h-[40px] w-full focus:outline-none placeholder:text-gray text-black font-itcbook text-[12px] p-2 placeholder:font-itcbook placeholder:text-[12px] rounded-md border-[0.5px] placeholder:text-opacity-50
            ${showError ? "border-error" : "border-green border-opacity-50"}
          `}
        />
        {showError && (
          <div className="absolute transition-opacity duration-300 left-2 -top-3">
            <div className="p-1 bg-white">
              <p className="text-error font-itcmedium text-[10px]">
                {getErrorMessage()}
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default InputField;